import { render } from "./OrderList.vue?vue&type=template&id=fc1a67da&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=fc1a67da&scoped=true&lang=css"
import "./OrderList.vue?vue&type=style&index=1&id=fc1a67da&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1a67da"]])

export default __exports__